module.exports = __webpack_public_path__ + "img/pinjia01.ab4fce76.jpg";